import { useContext } from 'react';

import { CartPaymentContext } from './CartPaymentContext';

export function useCartPayment() {
  return useContext(CartPaymentContext);
}
